module.exports = __webpack_public_path__ + "img/file---3077@1x.0105349e.png";